const prefix = '@SendDeletionRequestContainer/';

export default {
  SEND_DELETION_REQUEST: `${prefix}SEND_DELETION_REQUEST`,
  SEND_DELETION_REQUEST_REQUEST: `${prefix}SEND_DELETION_REQUEST_REQUEST`,
  SEND_DELETION_REQUEST_REQUEST_SUCCESS: `${prefix}SEND_DELETION_REQUEST_REQUEST_SUCCESS`,
  SEND_DELETION_REQUEST_REQUEST_ERROR: `${prefix}SEND_DELETION_REQUEST_REQUEST_ERROR`,

  OPEN_MODAL: `${prefix}OPEN_MODAL`,
  CLOSE_MODAL: `${prefix}CLOSE_MODAL`,
};
